import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StatementOfAccountsComponent} from './statement-of-accounts.component';
import {InputTextModule} from 'primeng/inputtext';
import {CalendarModule} from 'primeng/calendar';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InvoicesModule} from '../invoices/invoices.module';
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {SoaFiltersComponent} from './soa-filters/soa-filters.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {RippleModule} from 'primeng/ripple';
import {MenuModule} from 'primeng/menu';
import {PaginatorModule} from 'primeng/paginator';
import {SoaCardComponent} from './soa-card/soa-card.component';
import {TabViewModule} from 'primeng/tabview';
import {SoaTabletComponent} from './soa-tablet/soa-tablet.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ProgressBarModule} from 'primeng/progressbar';


@NgModule({
    declarations: [StatementOfAccountsComponent, SoaFiltersComponent, SoaCardComponent, SoaTabletComponent],
    imports: [
        CommonModule,
        InputTextModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        InvoicesModule,
        TableModule,
        ToastModule,
        SelectButtonModule,
        RippleModule,
        MenuModule,
        PaginatorModule,
        TabViewModule,
        ConfirmDialogModule,
        ProgressBarModule
    ]
})
export class StatementOfAccountsModule {
}
